export enum LaunchDarklyContextKind {
  User = 'user',
  Company = 'company',
}
